module Bookhus {
    export class NewsWidget {
        private container: any;
        private readonly isFullWidthLayout: boolean;

        private news: any[];
        private currentPage: number = 0;
        private timer: any;

        constructor(containerId: string) {
            this.container = $('#' + containerId);
            this.isFullWidthLayout = this.container.hasClass('container');

            this.init();
        }

        init():void {
            var self = this;
            if (self.getCookieValue() == "true") {
                self.drawSideWidget();
                return;
            }
            self.GetAllArticles().then((result) => {
                if (!result || result.length == 0) {
                    return;
                }

                self.news = result;
                self.drawContainer();
                self.drawPage(self.currentPage);
                self.initEvents();
                self.initTimer();

            });
        }

        initTimer() {
            var self = this;
            self.timer = setInterval(() => {
                if (!self.news || self.news.length == 0) {
                    clearInterval(this.timer);
                    return;
                }

                self.currentPage++
                self.drawPage(self.currentPage);
            }, 1000*10);
        }

        clearTimer() {
            var self = this;
            clearInterval(self.timer);
        }

        initEvents(): void {
            var self = this;
            self.container.find('.nav-arrow-left').on('click', () => {
                this.currentPage--;
                self.drawPage(this.currentPage);
                self.clearTimer();
            });
            self.container.find('.nav-arrow-right').on('click', () => {
                this.currentPage++;
                self.drawPage(this.currentPage);
                self.clearTimer();
            });
            self.container.find('a[data-command]').on('click', (e) => {
                e.preventDefault();
                var command = $(e.target).data('command').toString();
                switch (command) {
                    case "read":
                        $('.newsWidget-info-body').slideToggle(400, () => {
                            var display = $('.newsWidget-info-body').css('display');
                            $(e.target).html(display == "block" ? "Luk" : "Læs");
                            self.clearTimer();
                        });
                        break;
                    case "readAll":
                        window.location.href = "/nyheder";
                        break;
                }
            });
            self.container.find('.corner').on('click', () => {
                document.cookie = "newsRemoved=true";
                var widget = self.container.find('.newsWidget');
                widget.animate({
                    width: 0,
                    opacity: 0
                }, 500, () => {
                    self.container.children().remove();
                    self.drawSideWidget();
                });
            });
        }

        drawSideWidget(): void {
            var self = this;
            self.container.addClass('d-none');

            var html = `
                <div class="newsWidget-sidepanel ${self.isFullWidthLayout ? 'sidepanel-wide' : ''}">
                    <div class="sidepanel-icon bg-primary">
                        <i class="fas fa-expand-alt"></i>
                    </div>
                </div>`;

            $('body > .main').prepend(html);
            $('.newsWidget-sidepanel').on('click', (e) => {
                document.cookie = "newsRemoved=false";
                self.container.removeClass('d-none');
                self.init();
                $(e.currentTarget).remove();
            });
        }

        drawPage(page): void {
            var self = this;
            var current = this.news[Math.abs(page) % this.news.length];
            if (!current) {
                return;
            }

            self.container.children().fadeOut(400, () => {
                self.container.find('.newsWidget-info-title').html(current.title);
                self.container.find('.newsWidget-info-body').html(current.body);
                self.container.find('.newsWidget-info-publishdate').html("Publiceret den " + self.formatDate(current.publishDate));
                self.container.children().fadeIn();
            });
        }

        //getData(page): void {
        //    var self = this;
        //    if (page < 1) {
        //        //Sæt side til total, da kun nyhed kan vises af gangen
        //        page = self.total;
        //    }
        //    if (page > self.total) {
        //        page = 1;
        //    }
        //    $.ajax({
        //        url: '/api/news/getarticles?page=' + page,
        //        type: 'get',
        //        success: function (data) {
        //            self.container.children().fadeOut(400, () => {
        //                self.total = data.total;
        //                self.page = data.page;
        //                self.container.find('.newsWidget-info-title').html(data.article.title);
        //                self.container.find('.newsWidget-info-body').html(data.article.body);
        //                self.container.find('.newsWidget-info-publishdate').html("Publiceret den " + self.formatDate(data.article.publishDate));
        //                self.container.children().fadeIn();
        //            });
                    
        //        }
        //    });
        //}

        private formatDate(jsonDate: string) {
            var dateArray = jsonDate.split(/[-T:.]/);
            if (dateArray.length < 3) {
                return "";
            }
            return `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;
        }

        private getCookieValue(): string {
            var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)newsRemoved\s*\=\s*([^;]*).*$)|^.*$/, "$1");
            return cookieValue.length > 0 ? cookieValue : "";
        }

        drawContainer(): void {
            var self = this;
            var html =
                '<div class="container-news clearfix">' +
                    '<div class="newsWidget brand-background">' +
                        '<span class="fa fa-remove corner" title="Luk"></span>' +
                        '<div class="newsWidget-title">Nyheder</div>' +
                        '<div class="newsWidget-info-title "></div>' +
                        '<div class="newsWidget-info-body"></div>' +
                        
                        '<div class="nav-arrow nav-arrow-left"></div>' +
                        '<div class="nav-arrow nav-arrow-right"></div>' +
                        '<div style="text-align:center" class="foot-section">' +
                            '<a class="btn newsWidget-btn" data-command="read">Læs</a>' +
                            '<a class="btn newsWidget-btn" data-command="readAll">Se alle nyheder</a>' +
                            '<div class="newsWidget-info-publishdate"></div>' +
                        '</div>' +
                    '</div>' +
                '</div>';
            self.container.html($(html).hide());
        }

        getArticlesTotal(callback): void {
            $.ajax({ url: '/api/news/getarticlestotal', type: 'get', success: callback });
        }

        GetAllArticles(): JQueryXHR {
            return $.ajax({ url: '/api/news/getallarticles', type: 'get' });
        }
    }
}
var newswidget = new Bookhus.NewsWidget("newsContainer");